export enum RoomAccessForms {
  StaffList = 'StaffList',
  AssignRoom = 'AssignRoom',
}
